import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import './AdminLayout.css';

const AdminLayout = () => {
    return (
        <div className="admin-layout">
            <AdminSidebar />
            <div className="admin-main">
                <header className="admin-header">
                    <div className="admin-container">
                        <h2>لوحة التحكم</h2>
                    </div>
                </header>
                <div className="admin-content admin-container">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;
